export default "/images/921d137e94d84d3bf1da1de617bec37b.avif";